import { render, staticRenderFns } from "./BookContributorModal.vue?vue&type=template&id=f10d3992"
import script from "./BookContributorModal.vue?vue&type=script&lang=js"
export * from "./BookContributorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports